import React, { useState, useEffect } from 'react';
import { Checkbox, ColorPicker, InputBox } from '../shape.map';
import type { ShowValueColorOption } from '@/types/properties';
import type { DynamicComponentProps } from '@/types/commontypes';

const ShowValueColorOptionComponent: React.FC<DynamicComponentProps<ShowValueColorOption[]>> = ({
  value,
  onChange,
}) => {
  const [values, setValues] = useState<ShowValueColorOption[]>(value || []);

  useEffect(() => {
    setValues(value || []);
  }, [value]);

  const handleCheckboxChange = (index: number, checked: boolean) => {
    const updatedValues = [...values];
    updatedValues[index] = { ...updatedValues[index], show: checked };
    setValues(updatedValues);
    onChange(updatedValues);
  };

  const handleValueChange = (index: number, newValue: string | number) => {
    const updatedValues = [...values];
    updatedValues[index] = {
      ...updatedValues[index],
      value: typeof newValue === 'string' ? parseFloat(newValue) : newValue,
    };
    setValues(updatedValues);
    onChange(updatedValues);
  };

  const handleColorChange = (index: number, newColor: string) => {
    const updatedValues = [...values];
    updatedValues[index] = { ...updatedValues[index], color: newColor };
    setValues(updatedValues);
    onChange(updatedValues);
  };

  const renderColorOptions = () => {
    return (
      <div className="grid grid-cols-2 gap-4">
        {values.map((item, index) => {
          return (
            <div key={index} className="flex flex-col space-y-4">
              <div className="flex items-center space-x-4">
                <div className="flex-1">
                  <Checkbox value={item?.show || false} onChange={checked => handleCheckboxChange(index, checked)} />
                </div>

                <InputBox
                  type="number"
                  value={item?.value ?? 0}
                  onChange={(val: number | string) => handleValueChange(index, val)}
                  step="0.01"
                  min="0"
                  disabled={!item?.show}
                />

                <ColorPicker
                  value={item?.color || 'rgb(236, 197, 89)'}
                  onChange={(color: string) => handleColorChange(index, color)}
                  disabled={!item?.show}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return <div style={{ gridColumn: 'span 2' }}>{renderColorOptions()}</div>;
};

export default ShowValueColorOptionComponent;
